export const authorizedAppsTransformer = data => {
  const getAppRecords = (appData, type, isUnauthorized) => {
    return (
      appData?.records?.map(it => ({
        type,
        isUnauthorized,
        ...it,
      })) || []
    )
  }

  const authorizedApps = [
    ...getAppRecords(data?.authorizedApps?.staffApp, "web"),
    ...getAppRecords(data?.authorizedApps?.propGo, "dialer"),
    ...getAppRecords(data?.authorizedApps?.propPlus, "app"),
  ].sort((a, b) => new Date(b.lastLoginDate) - new Date(a.lastLoginDate))

  const unauthorizedApps = [
    ...getAppRecords(data?.unAuthorizedApps?.staffApp, "web", true),
    ...getAppRecords(data?.unAuthorizedApps?.propGo, "dialer", true),
    ...getAppRecords(data?.unAuthorizedApps?.propPlus, "app", true),
  ]

  return [...authorizedApps, ...unauthorizedApps]
}
